import { render, staticRenderFns } from "./PolicyAddToolbar.vue?vue&type=template&id=cce27b3e"
import script from "./PolicyAddToolbar.vue?vue&type=script&lang=js"
export * from "./PolicyAddToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports